module.exports = __webpack_public_path__ + "img/VC.ef05d463.png";